import styled from 'styled-components'
import PropTypes from 'prop-types'
import { Icon } from '@lmc/ui-kit'
import colors from '@lmc/common/constants'

export const BlankState = ({
  className,
  children,
  heading,
  component: Component,
  ...props
}) => {
  return (
    <StyledContainer as={Component} className={className} {...props}>
      <Icon name="SearchOutlined" style={styles.search} />
      {!!heading && <StyledHeading>{heading}</StyledHeading>}
      {children}
    </StyledContainer>
  )
}

const styles = {
  search: {
    fontSize: 50
  }
}

BlankState.propTypes = {
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.string]).isRequired,
  heading: PropTypes.string
}

BlankState.defaultProps = {
  component: 'div'
}

const StyledContainer = styled.div`
  background-color: ${colors.white};
  border-radius: 20px;
  color: ${colors.grey};
  padding: 4em 2em;
  text-align: center;
`

const StyledHeading = styled.h2`
  color: inherit;
  &:last-child {
    margin-bottom: 0;
  }
`

export default BlankState
